// Exports
export default {
	"permissionsWrapper": "permissionsWrapper_oBRGg",
	"groupTitle": "groupTitle_sKhJz"
};
